import { c as _c } from "react/compiler-runtime";
import constate from 'constate';
import { nets, tf } from 'face-api.js';
import { useEffect, useRef, useState } from 'react';
import { getLogger } from '@/idv/utils';
const {
  logInfo,
  logWarn,
  logError
} = getLogger({
  location: 'id-doc'
});
type FaceModelLoaderType = {
  isSelfieRequired: boolean;
};
export type FaceModelState = {
  modelsLoaded: boolean;
  /**
   * Autocapture is off for the rest of the session — the models could not load, or inference
   * failed. The manual shutter still works.
   */
  modelsUnavailable: boolean;
  /** Logs the first inference failure of the session, then latches modelsUnavailable. */
  reportInferenceFailure: (err: unknown) => void;
};
const useFaceModelLoader = t0 => {
  const $ = _c(7);
  const {
    isSelfieRequired
  } = t0;
  const [modelsLoaded, setModelsLoaded] = useState(false);
  const [modelsUnavailable, setModelsUnavailable] = useState(false);
  const inferenceFailedRef = useRef(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = err => {
      if (inferenceFailedRef.current) {
        return;
      }
      inferenceFailedRef.current = true;
      logWarn("Face detection failed at inference; disabling autocapture", err, {
        backend: tf.getBackend()
      });
      setModelsUnavailable(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const reportInferenceFailure = t1;
  let t2;
  let t3;
  if ($[1] !== isSelfieRequired) {
    t2 = () => {
      const loadModels = async () => {
        if (!isSelfieRequired) {
          return;
        }
        ;
        try {
          await tf.ready();
          const backend = tf.getBackend();
          if (backend !== "webgl") {
            logWarn("No WebGL backend for face detection; autocapture disabled", undefined, {
              backend
            });
            setModelsUnavailable(true);
            return;
          }
          await Promise.all([nets.tinyFaceDetector.loadFromUri("/model"), nets.faceLandmark68Net.loadFromUri("/model")]);
          logInfo("Face models loaded", {
            backend
          });
          setModelsLoaded(true);
        } catch (t4) {
          const err_0 = t4;
          logError("Error loading the face models", err_0);
          setModelsUnavailable(true);
        }
      };
      loadModels();
    };
    t3 = [isSelfieRequired];
    $[1] = isSelfieRequired;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== modelsLoaded || $[5] !== modelsUnavailable) {
    t4 = {
      modelsLoaded,
      modelsUnavailable,
      reportInferenceFailure
    };
    $[4] = modelsLoaded;
    $[5] = modelsUnavailable;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
const [FaceModelProvider, useFaceModel] = constate(useFaceModelLoader);
export { FaceModelProvider, useFaceModel };